// Skew-T and wind profile diagrams
@import './style/skewt.less';

// Desktop-specific styles
@import './style/desktop.less';

// Mobile-specific styles
@import './style/mobile.less';

#wsp-sounding {
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  p {
    margin: 0 0 0.3em;
    padding: 0;
  }

  a {
    font-weight: bold;
  }
}
